import { getTasks } from "@/api/endpoints";
import { RecordListPage } from "@/components/record-list-page";
import { Badge } from "@/components/ui/primitives";
import { useI18n } from "@/i18n";
import type { Task } from "@/types";

export function TasksPage() {
  const { t } = useI18n();

  const statusLabel = (status: Task["status"]) =>
    status === "done" ? t("statusDone") : status === "cancelled" ? t("statusCancelled") : t("statusOpen");

  return (
    <RecordListPage<Task>
      title={t("navTasks")}
      resource="tasks"
      fetcher={getTasks}
      renderRow={(task) => {
        const overdue =
          task.status === "open" && task.dueAt != null && new Date(task.dueAt) < new Date();

        return (
          <div className="flex items-center gap-3">
            <div className="min-w-0 flex-1">
              <p
                className={
                  task.status === "done"
                    ? "truncate font-medium text-muted-foreground line-through"
                    : "truncate font-medium"
                }
              >
                {task.title}
              </p>
              {task.description && (
                <p className="truncate text-sm text-muted-foreground">{task.description}</p>
              )}
            </div>
            {task.dueAt && (
              <Badge tone={overdue ? "danger" : "neutral"}>
                {overdue ? t("overdue") : new Date(task.dueAt).toLocaleDateString()}
              </Badge>
            )}
            <Badge tone={task.status === "open" ? "primary" : "neutral"}>
              {statusLabel(task.status)}
            </Badge>
          </div>
        );
      }}
    />
  );
}
